import apiRoutes from '@constants/apiRoutes';
import { authApi } from '@services/api';

interface SignInResponse {
  access: string;
  refresh: string;
  user: {
    id: string;
  };
}

interface SignInRequest {
  email: string;
  password: string;
}

interface GoogleSignInRequest {
  auth_code: string;
}

const signIn = authApi.injectEndpoints({
  endpoints: (builder) => ({
    signIn: builder.mutation<SignInResponse, SignInRequest>({
      query: (payload) => ({
        url: apiRoutes.signIn,
        method: 'POST',
        body: payload
      })
      // transformResponse: (data: SignInResponse) => data
    }),
    googleSignIn: builder.mutation<SignInResponse, GoogleSignInRequest>({
      query: (payload) => ({
        url: `${apiRoutes.signIn}google/`,
        method: 'POST',
        body: payload
      })
    })
  })
});

export const { useSignInMutation, useGoogleSignInMutation } = signIn;
